import React, { useState } from 'react';
import type { Organizer } from '@/types';
import { Modal } from '@/components/_shared/Modal/Modal';
import { useMediaQuery } from '@/hooks';
import { ScrollableDrawer } from '@/components/_shared/ScrollableDrawer/ScrollableDrawer';
import { AvatarComponent } from './AvatarComponent/AvatarComponent';
import { DialogContent } from './DialogContent/DialogContent';

interface OrganizerAvatarProps {
  organizer: Organizer;
  size?: 'small' | 'large';
}

export const OrganizerAvatar: React.FC<OrganizerAvatarProps> = ({ organizer, size = 'large' }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // TODO: This is a temporary solution to check if the screen is mobile.
  // We should use a more robust solution and receive that information from Cloudfront.
  const isMobile = useMediaQuery('(max-width: 743px)');

  const handleClose = () => setIsDialogOpen(false);
  const handleOpen = () => setIsDialogOpen(true);

  return (
    <>
      <AvatarComponent
        organizer={organizer}
        clickable={organizer.verified}
        onClick={organizer.verified ? handleOpen : undefined}
        size={size}
      />
      {isDialogOpen &&
        (isMobile ? (
          <ScrollableDrawer onClickOutside={handleClose}>
            {({ closeDrawer }) => <DialogContent organizer={organizer} closeDialog={closeDrawer} />}
          </ScrollableDrawer>
        ) : (
          <Modal visible={isDialogOpen} onClose={handleClose} type="simple">
            <DialogContent organizer={organizer} closeDialog={handleClose} />
          </Modal>
        ))}
    </>
  );
};
